import { render, staticRenderFns } from "./arrowbox.vue?vue&type=template&id=581ad628&scoped=true&"
import script from "./arrowbox.vue?vue&type=script&lang=js&"
export * from "./arrowbox.vue?vue&type=script&lang=js&"
import style0 from "./arrowbox.vue?vue&type=style&index=0&id=581ad628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ad628",
  null
  
)

export default component.exports